export default "__VITE_ASSET__Bqj9IyqU__"